// extracted by mini-css-extract-plugin
export default {"global-element-guide":"geg_global-element-guide__ihQUl","section-heading":"geg_section-heading__vuZ4M"};